// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3cAc4","title":"InfoRow_title__3hIQJ"};